/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ViewChild } from '@angular/core';
import { AnyoTableComponent } from 'projects/app-core/src/app/models/AnyoTableComponent';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import {
  ExtraSessionForPlanSubscription,
  TherapyPlansService,
} from '../../../services/therapy-plans.service';
import * as moment from 'moment';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import {
  TherapyPlanSubscriptionsFilter,
  TherapyPlanSubscriptionsGridRequest,
  TherapyPlanSubscriptionsSearch,
  TherapyPlanSubscriptionsTab,
} from '../../../models/therapyPlanSubscribtionGridRequest';
import {
  TherapyPlansSubcriptionGridResponseData,
  TherapyPlansSubscriptionGridResponse,
  TherapyPlansSubscriptionSessionDetails,
} from '../../../models/therapyPlansSubcriptionGridResponse';
import { ActivatedRoute } from '@angular/router';
import { IAnyoUser } from 'projects/app-core/src/auth/models/IAnyoUser';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { Permissions } from 'projects/app-core/src/auth/models/roles';
import { FileUtilsService } from 'projects/app-core/src/service/fileService';
import { TherapyPaymentType } from '../../../models/TherapyPlans';
import { lastValueFrom } from 'rxjs';
import { PlanSubscriptionTableComponent } from '../plan-subscription-table/plan-subscription-table.component';
import { TherapistService } from '../../../services/therapist.service';
import { TimeRangesResponse } from 'projects/admin/src/app/models/timeRangesRequestResponse';

interface TherapyPlanSubscriptionExportData {
  validTill: string;
  planPaused: string;
  planPausedAt: string;
  originalValidity: string;
  paymentType: TherapyPaymentType;
  zeroChargeSubscription: string;
  active: string;
  planName: string;
  vertical: string;
  concern: string;
  partnerId: string;
  noOfSessions: string;
  userEmail: string;
  purchasedAt: string;
  planValue?: number;
}

interface DropDownOptions {
  label: string;
  value: string;
}

@Component({
  selector: 'app-therapy-plans-subcription',
  templateUrl: './therapy-plans-subcription.component.html',
  styleUrl: './therapy-plans-subcription.component.scss',
})
export class TherapyPlansSubcriptionComponent extends AnyoTableComponent<
  TherapyPlansSubcriptionGridResponseData,
  TherapyPlanSubscriptionsGridRequest
> {
  planId: string = '';
  userId: string = '';
  color = '';
  selectedSubscription: TherapyPlansSubcriptionGridResponseData | undefined;
  showAddExtraSessionBtn = false;
  showSendFeedbackBtn = false;
  showTestUsers = true;
  isVisibleTransfer = false;
  selectedTherapistId = '';
  transferConfirmedSessions = false;
  feedbackSessionIds: string[] = [];
  affectedSessions: TherapyPlansSubscriptionSessionDetails[] = [];
  isVisibleSendFeedback = false;
  sendFeedbackSubscription: TherapyPlansSubcriptionGridResponseData | undefined;
  sendFeedbackTherapistOptions: DropDownOptions[] = [];
  sendFeedbackDefaultTherapistId: string | undefined;
  newTherapistEmail = '';
  tableData: TherapyPlansSubscriptionGridResponse = {
    data: [],
    filterOptions: {
      paymentTypes: [],
      tagsFilter: [],
    },
    pageNum: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    userDetails: undefined,
  };
  tabs = [
    TherapyPlanSubscriptionsTab.ACTIVE,
    TherapyPlanSubscriptionsTab.INACTIVE,
  ];
  selectedTab: number = 0;

  isWarningModalVisible = false;

  @ViewChild('activeTableComponent')
  activeTableComponent?: PlanSubscriptionTableComponent;
  @ViewChild('inActiveTableComponent')
  inActiveTableComponent?: PlanSubscriptionTableComponent;
  therapistName = '';
  therapistEmail = '';

  selectedSessionDate: Date | undefined;
  selectedSessionTime: Date | undefined;
  checkBoxTimeRangeOptions: {
    label: string;
    value: TimeRangesResponse;
    checked: boolean;
    disabled: boolean;
  }[] = [];
  sessionOkDisabled = true;

  setSelectedItem($event: any) {
    this.selectedSubscription = $event;
  }

  setTherapistName($event: any) {
    this.therapistName = $event;
  }

  setTherapistEmail($event: any) {
    this.therapistEmail = $event;
  }

  scrollToTop() {
    const element = document.getElementById('top-container');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  override async getData(): Promise<void> {
    if (this.planId) {
      this.gridRequest.filters = {
        [TherapyPlanSubscriptionsFilter.PAYMENT_TYPE]: [],
        [TherapyPlanSubscriptionsFilter.PARTNER_ID]: [],
        [TherapyPlanSubscriptionsFilter.PLAN_NAME]: [],
        [TherapyPlanSubscriptionsFilter.USER_ID]: [],
        [TherapyPlanSubscriptionsFilter.CONCERN]: [],
        [TherapyPlanSubscriptionsFilter.VERTICAL]: [],
        [TherapyPlanSubscriptionsFilter.TEST_USERS]: [],
        [TherapyPlanSubscriptionsFilter.TAGS]: [],
      };
      this.gridRequest.filters.PLAN_NAME = [this.planId];
    }
    if (this.userId) {
      this.gridRequest.filters = {
        [TherapyPlanSubscriptionsFilter.PAYMENT_TYPE]: [],
        [TherapyPlanSubscriptionsFilter.PARTNER_ID]: [],
        [TherapyPlanSubscriptionsFilter.PLAN_NAME]: [],
        [TherapyPlanSubscriptionsFilter.USER_ID]: [],
        [TherapyPlanSubscriptionsFilter.CONCERN]: [],
        [TherapyPlanSubscriptionsFilter.VERTICAL]: [],
        [TherapyPlanSubscriptionsFilter.TEST_USERS]: [],
        [TherapyPlanSubscriptionsFilter.TAGS]: [],
      };
      this.gridRequest.filters.USER_ID = [this.userId];
    }
    (this.gridRequest as TherapyPlanSubscriptionsGridRequest).tab =
      this.tabs[this.selectedTab];
    this.color = this.utils.getRandomColor();
    this.fetchTherapyPlans();
  }

  showTestUserFn() {
    if (!this.gridRequest.filters) {
      this.gridRequest.filters = {
        [TherapyPlanSubscriptionsFilter.PAYMENT_TYPE]: [],
        [TherapyPlanSubscriptionsFilter.PARTNER_ID]: [],
        [TherapyPlanSubscriptionsFilter.PLAN_NAME]: [],
        [TherapyPlanSubscriptionsFilter.USER_ID]: [],
        [TherapyPlanSubscriptionsFilter.CONCERN]: [],
        [TherapyPlanSubscriptionsFilter.VERTICAL]: [],
        [TherapyPlanSubscriptionsFilter.TEST_USERS]: [],
        [TherapyPlanSubscriptionsFilter.TAGS]: [],
      };
    }
    this.gridRequest.filters.TEST_USERS = [
      this.showTestUsers ? 'true' : 'false',
    ];
    this.fetchTherapyPlans();
  }

  override async ready(user?: IAnyoUser): Promise<void> {
    if (user) {
      if (
        user.customClaims?.additionalPermissions.includes(
          Permissions.AddExtraSessionToPlanSubscription,
        )
      ) {
        this.showAddExtraSessionBtn = true;
      }
      this.showSendFeedbackBtn =
        user.customClaims?.additionalPermissions?.includes(
          Permissions.SendFeedbackToTherapist,
        ) ?? false;
      this.activatedRoute.queryParams.subscribe((value) => {
        if (value) {
          this.planId = value['planName'];
          this.userId = value['userId'];
        }
      });
      this.getData();
    } else {
      this.data = [];
    }
    return;
  }

  constructor(
    protected override auth: AuthService,
    protected toast: ToastService,
    private therapyPlansService: TherapyPlansService,
    private activatedRoute: ActivatedRoute,
    public utils: UtilsService,
    private therapistService: TherapistService,
    private fileUtil: FileUtilsService,
  ) {
    super(auth, toast);
  }

  therapistDropdownData: DropDownOptions[] = [];

  showModalTransfer(data: TherapyPlansSubcriptionGridResponseData): void {
    this.selectedSubscription = data;
    this.computeAffectedConfirmedSessions();
    this.pageLoading = true;
    this.therapyPlansService
      .getTherapistsForTransfer({
        verticalId: data.verticalId,
        concernId: data.concernId,
      })
      .subscribe({
        next: (value) => {
          this.therapistDropdownData = [];
          value.forEach((data) => {
            if (
              this.selectedSubscription!.sessionDetails[1].therapistId! !==
              data.id
            ) {
              this.therapistDropdownData.push({
                label: data.name,
                value: data.id,
              });
            }
          });
          this.pageLoading = false;
          this.isVisibleTransfer = true;
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody.description);
          this.isVisibleTransfer = false;
          this.pageLoading = false;
        },
      });
  }
  transferTherapistLoading = false;
  handleWarningModalConfirm() {
    this.isWarningModalVisible = false;
    this.onSubmitTransfer();
  }

  handleWarningModalBack() {
    this.isWarningModalVisible = false;
  }
  handleTransferTherapist() {
    if (this.affectedSessions.length > 0 && !this.transferConfirmedSessions) {
      this.isWarningModalVisible = true;
      return;
    }
    this.onSubmitTransfer();
  }
  onSubmitTransfer() {
    this.transferTherapistLoading = true;
    const newSessionDateTime =
      this.selectedSessionDate && this.selectedSessionTime
        ? moment(this.selectedSessionDate)
          .set({
            hour: moment(this.selectedSessionTime).hour(),
            minute: moment(this.selectedSessionTime).minute(),
          })
          .valueOf()
        : undefined;
    const selectedSlot = this.checkBoxTimeRangeOptions.find(
      (o) => o.checked,
    )?.value;
    const sessionToReschedule =
      this.selectedSubscription?.sessionDetailslist.find(
        (s) => s.sessionBooked && !s.sessionCompleted,
      ) ||
      this.selectedSubscription?.sessionDetailslist.find(
        (s) => !s.sessionCompleted,
      );
    const rescheduleSlots =
      selectedSlot && sessionToReschedule && this.selectedSessionDate
        ? (() => {
          const slotDate = moment(this.selectedSessionDate);
          const startMoment = moment(selectedSlot.start, 'hh:mm a');
          const endMoment = moment(selectedSlot.end, 'hh:mm a');
          const startEpoch = slotDate
            .clone()
            .set({
              hour: startMoment.hour(),
              minute: startMoment.minute(),
              second: 0,
              millisecond: 0,
            })
            .format('x');
          const endEpoch = slotDate
            .clone()
            .set({
              hour: endMoment.hour(),
              minute: endMoment.minute(),
              second: 0,
              millisecond: 0,
            })
            .format('x');
          return [
            {
              sessionId: (sessionToReschedule.sessionId ||
                sessionToReschedule.id!) as string,
              startTime: startEpoch,
              endTime: endEpoch,
            },
          ];
        })()
        : undefined;

    this.therapyPlansService
      .saveTherapistsForTransfer({
        newTherapistId: this.selectedTherapistId,
        planSubscriptionId: this.selectedSubscription?.id || '',
        transferConfirmedSessions: this.transferConfirmedSessions,
        newSessionDateTime,
        rescheduleSlots,
        feedbackSessionIds: this.feedbackSessionIds,
      })
      .subscribe({
        next: () => {
          this.toastService.showSuccess('Successfully Transfered');
          this.fetchTherapyPlans();
          this.transferTherapistLoading = false;
          this.isVisibleTransfer = false;
          this.resetTransferModal();
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody.description);
          this.transferTherapistLoading = false;
          this.isVisibleTransfer = false;
          this.fetchTherapyPlans();
        },
      });
  }

  getSelectedTherapistName(): string {
    const selectedTherapist = this.therapistDropdownData.find(
      (t) => t.value === this.selectedTherapistId,
    );
    return selectedTherapist ? selectedTherapist.label : 'N/A';
  }
  onNewTherapistSelected(id: string) {
    this.selectedTherapistId = id;
    this.checkBoxTimeRangeOptions = [];
    this.selectedSessionDate = undefined;
    this.selectedSessionTime = undefined;
    this.sessionOkDisabled = true;
  }

  // grid
  therapyPlans: TherapyPlansSubcriptionGridResponseData[] = [];
  totalRecords: number = 0;

  page = 1;
  validTillColumnFilterDate: Date[] = [];
  purchasedAtColumnFilterDate: Date[] = [];

  validTillFilterDateChange($event: Date[]) {
    if ($event && $event.length == 2) {
      const startDate = moment($event[0]).startOf('day').toDate();
      const endDate = moment($event[1]).endOf('day').toDate();
      const isToday = moment(startDate).isSame(endDate, 'day');
      this.gridRequest = {
        dateFilters: {
          VALID_TILL: {
            from: isToday
              ? moment($event[0]).startOf('day').toDate()
              : startDate,
            to: isToday ? moment($event[1]).endOf('day').toDate() : endDate,
          },
        },
        export: false,
        filters: {
          USER_ID: [this.userId],
        },
        from: undefined,
        globalSearch: this.gridRequest.globalSearch ?? [],
        page: 1,
        pageSize: this.pageSize,
        searchQuery: undefined,
        to: undefined,
        tab: this.tabs[this.selectedTab],
      };
    }
  }

  purchasedAtFilterDateChange($event: Date[]) {
    if ($event && $event.length == 2) {
      const startDate = moment($event[0]).startOf('day').toDate();
      const endDate = moment($event[1]).endOf('day').toDate();
      const isToday = moment(startDate).isSame(endDate, 'day');
      this.gridRequest = {
        dateFilters: {
          CREATED_AT: {
            from: isToday
              ? moment($event[0]).startOf('day').toDate()
              : startDate,
            to: isToday ? moment($event[1]).endOf('day').toDate() : endDate,
          },
        },
        export: false,
        filters: {
          USER_ID: [this.userId],
        },
        from: undefined,
        globalSearch: this.gridRequest.globalSearch ?? [],
        page: 1,
        pageSize: this.pageSize,
        searchQuery: undefined,
        to: undefined,
        tab: this.tabs[this.selectedTab],
      };
    }
  }

  fetchTherapyPlans() {
    this.pageLoading = true;
    this.therapyPlans = [];
    this.therapyPlansService
      .fetchTherapyPlansSubscription(this.gridRequest)
      .subscribe({
        next: (value) => {
          value.data.forEach((data) => {
            data.paymentTypeColor = this.utils.getRandomColor();
            const sessionList = Object.keys(data.sessionDetails).map((key) => {
              const session = data.sessionDetails[key];
              return { id: key, ...session };
            });
            data.sessionDetailslist = sessionList;
          });
          this.therapyPlans = value.data;
          this.tableData = value;
          if (this.activeTableComponent) {
            this.activeTableComponent?.setPaymentTypeTherapyPlanSubscriptionGridFilterData(
              value,
            );
            this.activeTableComponent?.setTagTherapyPlanSubscriptionGridFilterData(
              value,
            );
          }

          if (this.inActiveTableComponent) {
            this.inActiveTableComponent?.setPaymentTypeTherapyPlanSubscriptionGridFilterData(
              value,
            );
            this.inActiveTableComponent?.setTagTherapyPlanSubscriptionGridFilterData(
              value,
            );
          }
          if (this.selectedSubscription?.id) {
            this.selectedSubscription =
              value.data.find(
                item => item.id === this.selectedSubscription?.id
              ) || undefined;
          }
          this.totalRecords = value.totalRecords;
          this.pageLoading = false;
        },
        error: (err) => {
          this.toastService.showError(err.message);
          this.pageLoading = false;
        },
      });
  }

  searchGlobal() {
    this.gridRequest.page = 1;
    this.gridRequest.globalSearch = this.globalSearchInput.trim()
      ? [this.globalSearchInput.trim()]
      : [];
    this.fetchTherapyPlans();
  }

  searchByPlanName($event: string) {
    if ($event) {
      this.gridRequest.searchQuery = {
        [TherapyPlanSubscriptionsSearch.USER_NAME]: '',
        [TherapyPlanSubscriptionsSearch.PLAN_NAME]: '',
      };
      this.gridRequest.searchQuery.PLAN_NAME = $event.trim();
      this.fetchTherapyPlans();
    }
  }

  // searchByUserName(){
  //   if(this.userNameColumnSearch){
  //     this.gridRequest.searchQuery = {
  //       [TherapyPlanSubscriptionsSearch.USER_NAME] : '',
  //       [TherapyPlanSubscriptionsSearch.PLAN_NAME]: ''
  //     }
  //     this.gridRequest.searchQuery.USER_NAME = this.userNameColumnSearch.trim()
  //     this.fetchTherapyPlans()
  //   }
  // }

  paymentTypeFilterChangeFn($event: any[]) {
    if (!this.gridRequest.filters) {
      this.gridRequest.filters = {
        [TherapyPlanSubscriptionsFilter.PAYMENT_TYPE]: [],
        [TherapyPlanSubscriptionsFilter.PARTNER_ID]: [],
        [TherapyPlanSubscriptionsFilter.PLAN_NAME]: [],
        [TherapyPlanSubscriptionsFilter.USER_ID]: [],
        [TherapyPlanSubscriptionsFilter.CONCERN]: [],
        [TherapyPlanSubscriptionsFilter.VERTICAL]: [],
        [TherapyPlanSubscriptionsFilter.TEST_USERS]: [],
        [TherapyPlanSubscriptionsFilter.TAGS]: [],
      };
    }
    if ($event && $event.length) {
      this.gridRequest.filters.PAYMENT_TYPE = $event;
    }
  }

  tagsFilterChangeFn($event: string[]) {
    if (!this.gridRequest.filters) {
      this.gridRequest.filters = {
        [TherapyPlanSubscriptionsFilter.PAYMENT_TYPE]: [],
        [TherapyPlanSubscriptionsFilter.PARTNER_ID]: [],
        [TherapyPlanSubscriptionsFilter.PLAN_NAME]: [],
        [TherapyPlanSubscriptionsFilter.USER_ID]: [this.userId],
        [TherapyPlanSubscriptionsFilter.CONCERN]: [],
        [TherapyPlanSubscriptionsFilter.VERTICAL]: [],
        [TherapyPlanSubscriptionsFilter.TEST_USERS]: [],
        [TherapyPlanSubscriptionsFilter.TAGS]: [],
      };
    }
    if ($event && $event.length) {
      this.gridRequest.filters.TAGS = $event;
    }
  }
  resetTransferModal(): void {
    this.selectedTherapistId = '';
    this.selectedSessionDate = undefined;
    this.selectedSessionTime = undefined;
    this.transferConfirmedSessions = false;
    this.affectedSessions = [];
    this.checkBoxTimeRangeOptions = [];
    this.sessionOkDisabled = true;
    this.newTherapistEmail = '';
    this.feedbackSessionIds = [];
  }

  showModalSendFeedback(data: TherapyPlansSubcriptionGridResponseData): void {
    this.sendFeedbackSubscription = data;
    // The therapist of the latest session is the plan's current therapist.
    const sessions = data.sessionDetailslist || Object.values(data.sessionDetails);
    this.sendFeedbackDefaultTherapistId =
      sessions[sessions.length - 1]?.therapistId;
    this.pageLoading = true;
    this.therapyPlansService
      .getTherapistsForTransfer({
        verticalId: data.verticalId,
        concernId: data.concernId,
      })
      .subscribe({
        next: (value) => {
          this.sendFeedbackTherapistOptions = value.map((t) => ({
            label: t.name,
            value: t.id,
          }));
          this.pageLoading = false;
          this.isVisibleSendFeedback = true;
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody.description);
          this.pageLoading = false;
        },
      });
  }

  override async resetFilter() {
    this.globalSearchInput = '';
    this.gridRequest = {
      export: false,
      globalSearch: [],
      page: 1,
      pageSize: this.pageSize,
      tab: this.tabs[this.selectedTab],
      filters: {
        [TherapyPlanSubscriptionsFilter.PAYMENT_TYPE]: [],
        [TherapyPlanSubscriptionsFilter.PARTNER_ID]: [],
        [TherapyPlanSubscriptionsFilter.PLAN_NAME]: [],
        [TherapyPlanSubscriptionsFilter.USER_ID]: [this.userId],
        [TherapyPlanSubscriptionsFilter.CONCERN]: [],
        [TherapyPlanSubscriptionsFilter.VERTICAL]: [],
        [TherapyPlanSubscriptionsFilter.TEST_USERS]: [],
      },
    };
    if (this.activeTableComponent) {
      this.activeTableComponent.resetValues();
    }
    if (this.inActiveTableComponent) {
      this.inActiveTableComponent.resetValues();
    }

    this.fetchTherapyPlans();
  }

  tabChange($event: any) {
    this.globalSearchInput = '';
    this.selectedTab = $event.index!;
    this.tableData = {
      data: [],
      filterOptions: {
        paymentTypes: [],
        tagsFilter: [],
      },
      pageNum: 1,
      pageSize: 10,
      totalPages: 0,
      totalRecords: 0,
      userDetails: undefined,
    };

    this.gridRequest = {
      export: false,
      sort: undefined,
      filters: {
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        HIDE_TEST_BOOKING: ['true'],
        USER_ID: [this.userId],
        PARTNER_ID: [],
        SESSION_TAG: [],
      },
      globalSearch: [],
      page: 1,
      pageSize: this.pageSize,
      tab: this.tabs[this.selectedTab],
    };
    if (this.activeTableComponent) {
      this.activeTableComponent.resetValues();
    }
    if (this.inActiveTableComponent) {
      this.inActiveTableComponent.resetValues();
    }

    if ($event.index == 0) {
      (this.gridRequest as TherapyPlanSubscriptionsGridRequest)!.tab =
        TherapyPlanSubscriptionsTab.ACTIVE;
    }
    if ($event.index == 1) {
      (this.gridRequest as TherapyPlanSubscriptionsGridRequest)!.tab =
        TherapyPlanSubscriptionsTab.INACTIVE;
    }
    this.fetchTherapyPlans();
  }

  dateFormat = 'dd/MM/yyyy';
  dateRange: Date[] | undefined;
  globalSearchInput = '';

  disabledDate = (current: Date) => {
    return moment(current).isBefore(moment('01/10/2023', 'dd/MM/YYYY'));
  };

  dateChange(_: Date[]) {
    if (this.dateRange && this.dateRange.length == 2) {
      this.gridRequest!.from = Number(moment(this.dateRange[0]).format('x'));
      this.gridRequest!.to = Number(moment(this.dateRange[1]).format('x'));
    }
    this.fetchTherapyPlans();
  }

  async exportDataFn() {
    this.pageLoading = true;
    this.gridRequest.export = true;
    const gridResp = await lastValueFrom(
      this.therapyPlansService.fetchTherapyPlansSubscription(this.gridRequest!),
    );
    const exportData = gridResp.data.map((value) => {
      const payload: TherapyPlanSubscriptionExportData = {
        validTill: moment(value.validTill, 'x').format('DD/MM/YYYY'),
        planPaused: value.planPaused ? 'Yes' : 'No',
        planPausedAt: moment(value.validTill, 'x').format('DD/MM/YYYY'),
        originalValidity: moment(value.originalValidity, 'x').format(
          'DD/MM/YYYY',
        ),
        paymentType: value.paymentType,
        zeroChargeSubscription: value.zeroChargeSubscription ? 'Yes' : 'No',
        active: value.active ? 'Yes' : 'No',
        planName: value.planName,
        vertical: value.vertical,
        concern: value.concern,
        partnerId: value.partnerId,
        noOfSessions: value.noOfSessions,
        userEmail: value.userDetails.email,
        purchasedAt: moment(value.purchasedAt, 'x').format('DD/MM/YYYY'),
        planValue: value.planValue || 0,
      };
      return payload;
    });
    try {
      this.fileUtil.exportCSV<TherapyPlanSubscriptionExportData>(
        exportData,
        `theparyplan_subscriptions_export_${moment().format('dd/mm/yyy hh:mm a')}`,
      );
      this.pageLoading = false;
    } catch (e) {
      this.toastService.showError('Export Error');
      this.pageLoading = false;
    }
  }
  isVisible = false;
  extraSessionName = '';
  extraSessionDescription = '';
  showModal(): void {
    this.extraSessionName = `Session ${parseInt(this.selectedSubscription!.noOfSessions) + 1}`;
    this.extraSessionDescription = '';
    this.isVisible = true;
  }

  handleOk(): void {
    this.pageLoading = true;
    const sessionDetails = this.selectedSubscription!.sessionDetails!;
    sessionDetails[parseInt(this.selectedSubscription!.noOfSessions) + 1] = {
      therapistId:
        this.selectedSubscription!.sessionDetailslist[0].therapistId!,
      therapistEmail:
        this.selectedSubscription?.sessionDetailslist[0].therapistEmail,
      therapistName:
        this.selectedSubscription?.sessionDetailslist[0].therapistName,
      sessionName: this.extraSessionName,
      description: this.extraSessionDescription,
      sessionBooked: false,
      sessionCompleted: false,
    };
    const req: ExtraSessionForPlanSubscription = {
      sessionDetails: sessionDetails,
    };
    this.therapyPlansService
      .addExtraSessions(this.selectedSubscription!.id!, req)
      .subscribe({
        next: () => {
          this.toastService.showSuccess('extra sessions added');
          this.pageLoading = false;
          this.isVisible = false;
          this.fetchTherapyPlans();
        },
        error: (err) => {
          this.pageLoading = false;
          const errorBody = err.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody.description);
          this.isVisible = false;
        },
      });
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  handleCancelTransfer(): void {
    console.log('Button cancel clicked!');
    this.isVisibleTransfer = false;
    this.resetTransferModal();
  }

  onNewSessionDateChange($event: Date) {
    if (!moment($event).startOf('day').isSameOrAfter(moment().startOf('day'))) {
      this.toastService.showError('Date should be in future');
      return;
    }
    this.selectedSessionDate = $event;
    this.onChange($event);
    this.sessionOkDisabled = !this.selectedSessionTime;
  }

  onChange(result: Date) {
    const request = {
      therapistId: this.selectedTherapistId || '',
      date: moment(result).format('x'),
    };

    this.therapistService.getTimeRangesForSelectedDay(request).subscribe({
      next: (therapistTimeSlots) => {
        this.checkBoxTimeRangeOptions = [];
        therapistTimeSlots.forEach((timeSlot: TimeRangesResponse) => {
          if (!timeSlot.notAvailableSlotExists) {
            this.checkBoxTimeRangeOptions.push({
              label: `${timeSlot.start} - ${timeSlot.end}`,
              value: timeSlot,
              checked: false,
              disabled: !timeSlot.available,
            });
          }
        });
        this.sessionOkDisabled = !this.selectedSessionTime;
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  onNewSessionTimeChange($event: TimeRangesResponse[]) {
    if ($event && $event.length > 0) {
      this.selectedSessionTime = moment($event[0].start, 'hh:mm a').toDate();
      this.sessionOkDisabled = !(
        this.selectedSessionDate && this.selectedSessionTime
      );
    }
  }

  onCheckboxClick($event: boolean, selectedIndex: number) {
    this.checkBoxTimeRangeOptions.forEach((option, index) => {
      option.checked = index === selectedIndex;
    });
  }

  computeAffectedConfirmedSessions() {
    if (!this.selectedSubscription) {
      this.affectedSessions = [];
      return;
    }
    const now = moment();
    this.affectedSessions = (
      this.selectedSubscription.sessionDetailslist || []
    ).filter(
      (s) =>
        s.sessionBooked &&
        s.sessionStatus === 'Confirmed' &&
        s.sessionDate &&
        moment(s.sessionDate).isAfter(now),
    );
  }

  onTransferConfirmedToggle(val: boolean) {
    this.transferConfirmedSessions = val;
    if (val) {
      this.computeAffectedConfirmedSessions();
    } else {
      this.affectedSessions = [];
    }
  }

  formatDateTime(date?: Date) {
    return date ? moment(date).format('DD/MM/YYYY hh:mm A') : 'N/A';
  }

  selectedSubscriptionId = '';
  deactivePlanModalVisible = false;
  blockPlanModalVisible = false;
  blockMessage = '';

  handleCancelDeactivePlan() {
    this.deactivePlanModalVisible = false;
  }

  handleOkDeactivePlan() {
    this.pageLoading = true;
    this.therapyPlansService
      .adminDeacrtivedPlan(this.selectedSubscriptionId)
      .subscribe({
        next: () => {
          this.toastService.showSuccess('Plan Subscription deactivated');
          this.deactivePlanModalVisible = false;
          this.pageLoading = false;
          this.fetchTherapyPlans();
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody.description);
          this.deactivePlanModalVisible = false;
          this.pageLoading = false;
        },
      });
  }

  onBlockSubscription(planSubscriptionId: string) {
    this.selectedSubscriptionId = planSubscriptionId;
    this.blockPlanModalVisible = true;
  }
  handleCancelBlockPlan() {
    this.blockPlanModalVisible = false;
  }
  handleOkBlockPlan() {
    this.pageLoading = true;
    this.therapyPlansService
      .adminBlockPlan({
        planSubscriptionId: this.selectedSubscriptionId,
        blockMessage: this.blockMessage,
      })
      .subscribe({
        next: () => {
          this.toastService.showSuccess('Plan Subscription Blocked');
          this.blockPlanModalVisible = false;
          this.pageLoading = false;
          this.fetchTherapyPlans();
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody.description);
          this.blockPlanModalVisible = false;
          this.pageLoading = false;
        },
      });
  }

  blockMessageModalVisible = false;
  blockMessageText = '';
  openBlockMessageModal(message: string) {
    this.blockMessageText = message;
    this.blockMessageModalVisible = true;
  }
  handleCancelBlockMessage() {
    this.blockMessageModalVisible = false;
  }
}
